{
  "faqHeading": "Frequently asked questions",
  "cities": {
    "nice": {
      "sections": [
        {
          "heading": "Top things to do in Nice",
          "paragraphs": [
            "Start in Vieux Nice, the old town of narrow lanes and ochre façades, and the Cours Saleya market: flowers and local produce every morning except Monday, when the square fills with antique stalls. Climb Castle Hill (Colline du Château) — on foot or by the lift — for the classic view over the Baie des Anges, then walk the Promenade des Anglais, the 7 km seafront that helped earn Nice its UNESCO World Heritage listing as a winter resort town in 2021.",
            "Nice is also a serious art city. The Musée Matisse sits among the olive trees of Cimiez, the Marc Chagall National Museum holds his Biblical Message cycle, and MAMAC covers modern and contemporary art from the 1950s onwards. Between museums, the Promenade du Paillon park links the old town to Place Masséna, and Port Lympia's quays are the place for an evening drink."
          ]
        },
        {
          "heading": "Events and the best time to visit Nice",
          "paragraphs": [
            "The year opens with the Nice Carnival in February — two weeks of parades and the famous flower battles on the Promenade. Summer brings the Nice Jazz Festival in July, open-air concerts at the Théâtre de Verdure and fireworks over the bay, while autumn and winter are the season for theatre, opera at the Opéra de Nice and big exhibitions.",
            "May, June and September are the sweet spot: warm sea, long days and fewer crowds than July and August. Winters are mild enough for lunch on a terrace, which is exactly why Nice became a resort in the first place. Check the events above for what's on during your dates."
          ]
        },
        {
          "heading": "Getting to Nice and getting around",
          "paragraphs": [
            "Nice Côte d'Azur Airport is the Riviera's main international gateway, just 7 km from the centre; tram line 2 runs from both terminals to the city centre and the port. Nice-Ville station has TGV connections to Paris and regional TER trains along the coast.",
            "The centre is compact and walkable, and trams and Lignes d'Azur buses cover the rest. Nice is also the most practical base on the Côte d'Azur: by train, Villefranche-sur-Mer is under 10 minutes away, Monaco and Antibes around 20–25 minutes, and Cannes or Menton well under an hour."
          ]
        }
      ],
      "faq": [
        {
          "q": "How many days do you need in Nice?",
          "a": "Two or three days cover the old town, Castle Hill, the Promenade des Anglais and a museum or two. With four or five days you can use Nice as a base for day trips to Monaco, Villefranche-sur-Mer, Èze, Antibes or Cannes, all easy to reach by train."
        },
        {
          "q": "What is the best time to visit Nice?",
          "a": "May, June and September offer warm weather and a swimmable sea without peak-season crowds. February is worth it for the Nice Carnival, and July for the Nice Jazz Festival, but book early for both."
        },
        {
          "q": "How do I get from Nice airport to the city centre?",
          "a": "Tram line 2 connects both airport terminals with the city centre and the port in about 25–30 minutes. Taxis and ride-hailing cars are also available outside the terminals."
        },
        {
          "q": "Is Nice a good base for exploring the French Riviera?",
          "a": "Yes. Nice sits in the middle of the coast with the region's main airport and train station, so Monaco, Menton, Villefranche-sur-Mer, Antibes and Cannes are all within an hour by train, and many tours and day trips depart from the city."
        }
      ]
    },
    "cannes": {
      "sections": [
        {
          "heading": "Top things to do in Cannes",
          "paragraphs": [
            "Walk La Croisette, the palm-lined seafront of grand hotels and private beaches, to the Palais des Festivals, where anyone can pose on the famous red-carpet steps. Then climb into Le Suquet, the old quarter on the hill, for its cobbled lanes, the Notre-Dame d'Espérance church and the castle museum at the top, with one of the best views over the bay.",
            "The best escape from the bustle is offshore. Boats from the Vieux Port reach the Lérins Islands in minutes: Sainte-Marguerite has pine forests, clear coves and the Fort Royal, where the Man in the Iron Mask was held; Saint-Honorat is home to a working monastery whose monks make their own wine. Back in town, the covered Marché Forville is the place to shop like a local."
          ]
        },
        {
          "heading": "Events and the best time to visit Cannes",
          "paragraphs": [
            "Cannes is an events city. The Film Festival takes over in May — most screenings are for accredited guests, but the red-carpet arrivals and the free open-air Cinéma de la Plage are open to everyone. Summer brings the fireworks festival over the bay, and September the Cannes Yachting Festival, one of Europe's largest in-water boat shows. Year-round, the Palais hosts concerts, shows and trade fairs.",
            "For beaches and a calm Croisette, aim for June or September. Prices and crowds peak during the Film Festival and in July and August, so book well ahead if your dates overlap."
          ]
        },
        {
          "heading": "Getting to Cannes and getting around",
          "paragraphs": [
            "The nearest major airport is Nice Côte d'Azur, around 30 km away, with direct buses to Cannes. Cannes station is right in the centre, on the coastal line between Marseille and Nice, with TGVs from Paris and frequent regional trains — Nice is about 30–40 minutes away.",
            "The centre, La Croisette and Le Suquet are all walkable. Local buses serve the outer neighbourhoods, and ferries to the Lérins Islands leave from the Vieux Port throughout the day."
          ]
        }
      ],
      "faq": [
        {
          "q": "Can the public attend the Cannes Film Festival?",
          "a": "Official screenings are mostly reserved for accredited professionals and invited guests, but anyone can watch the red-carpet arrivals outside the Palais des Festivals and attend the free Cinéma de la Plage screenings on the beach during the festival."
        },
        {
          "q": "How do I get to the Lérins Islands from Cannes?",
          "a": "Ferries leave from the Vieux Port, next to the Palais des Festivals. The crossing to Île Sainte-Marguerite takes about 15 minutes; Île Saint-Honorat is served by the monastery's own boats. Take water and a picnic — facilities on the islands are limited."
        },
        {
          "q": "How far is Cannes from Nice?",
          "a": "About 30 km. Regional trains take around 30–40 minutes between the two city centres, and there are direct buses from Nice airport."
        },
        {
          "q": "When is the best time to visit Cannes?",
          "a": "June and September combine warm weather and a swimmable sea with fewer crowds. Visit in May for the Film Festival atmosphere, or in September for the Cannes Yachting Festival — but expect higher hotel prices on those dates."
        }
      ]
    },
    "monaco": {
      "sections": [
        {
          "heading": "Top things to do in Monaco",
          "paragraphs": [
            "Monaco has two faces. On the Rock (Monaco-Ville), the old town, you'll find the Prince's Palace — with the changing of the guard every day at 11:55 — the cathedral where Princess Grace is buried, and the Oceanographic Museum, perched on the cliff since 1910 and once directed by Jacques-Yves Cousteau. Across the harbour, Monte-Carlo is all Belle Époque glamour: the Casino, the Opéra de Monte-Carlo and the gardens in front of the Hôtel de Paris.",
            "Walk around Port Hercule to see the superyachts and trace part of the Grand Prix circuit, from the harbour chicane to the tunnel. For a swim, Larvotto beach is the principality's public beach, and dozens of free public lifts and escalators make the steep streets much easier than they look."
          ]
        },
        {
          "heading": "Events and the best time to visit Monaco",
          "paragraphs": [
            "Monaco's calendar is packed with world-class events: the International Circus Festival and the Monte-Carlo Rally in January, the Monte-Carlo Masters tennis in April, the Formula 1 Grand Prix in late May or early June, the Monaco Yacht Show in September, and a busy season of opera, ballet and concerts through winter.",
            "Spring and early autumn are ideal for sightseeing. Grand Prix week is unforgettable but crowded and expensive — book months ahead or visit the week after, when the circuit is still partly visible. Check the events above for concerts and shows during your stay."
          ]
        },
        {
          "heading": "Getting to Monaco and getting around",
          "paragraphs": [
            "There's no airport in Monaco: most visitors fly into Nice, around 30 km away, then take the train, a bus, or a 7-minute helicopter transfer. Trains from Nice reach Monaco-Monte-Carlo station in about 20 minutes, and Menton is 10 minutes further east.",
            "Monaco covers about 2 km², so it's easy to explore on foot, helped by public lifts and a good local bus network. The Bateau Bus, a small ferry across Port Hercule, saves the walk around the harbour."
          ]
        }
      ],
      "faq": [
        {
          "q": "Do I need a passport to visit Monaco?",
          "a": "There are no border controls between France and Monaco, so you simply walk or drive in. Carry your passport or national ID card anyway — it's required to enter the Casino's gaming rooms and useful for hotel check-in. Monaco uses the euro."
        },
        {
          "q": "Can you visit the Monte-Carlo Casino without gambling?",
          "a": "Yes. The atrium is open to all visitors, and the gaming rooms can be toured in the morning for an entry fee. Visitors must be over 18 with ID, and smart dress is expected in the evening."
        },
        {
          "q": "How do I get from Nice to Monaco?",
          "a": "The regional train is the easiest option: about 20 minutes from Nice-Ville to Monaco-Monte-Carlo, with frequent departures. Buses run along the coast road, and helicopters from Nice airport take around 7 minutes."
        },
        {
          "q": "Is one day enough for Monaco?",
          "a": "One full day covers the Rock with the Prince's Palace and the Oceanographic Museum, plus the Casino and Port Hercule in Monte-Carlo. Stay overnight if you want to see the Casino square lit up or catch a show at the Opéra."
        }
      ]
    },
    "antibes": {
      "sections": [
        {
          "heading": "Top things to do in Antibes",
          "paragraphs": [
            "Antibes' old town sits behind sea walls rebuilt by Vauban. Start at the Château Grimaldi, where Picasso worked in 1946 and which now houses the Musée Picasso, then wander down to the covered Marché Provençal on Cours Masséna for olives, cheese and flowers. From the Bastion Saint-Jaume, Jaume Plensa's giant Nomade sculpture looks out over the sea.",
            "Port Vauban is one of Europe's largest marinas, with the famous 'billionaires' quay' of superyachts beneath the star-shaped Fort Carré. Beyond town, the Cap d'Antibes coastal path winds along wild limestone shores, and the Garoupe lighthouse offers views from the Alps to the Esterel."
          ]
        },
        {
          "heading": "Events and the best time to visit Antibes",
          "paragraphs": [
            "Summer belongs to Juan-les-Pins, Antibes' seaside twin, where Jazz à Juan has filled the Pinède Gould pine grove every July since 1960. The rest of the year the town keeps a lively programme of concerts, exhibitions and markets, and the old town is at its most atmospheric out of season.",
            "Late spring and September are the best months for combining sightseeing with the sandy beaches of Juan-les-Pins and La Garoupe. July and August are busy but festive, with jazz, evening markets and nightlife."
          ]
        },
        {
          "heading": "Getting to Antibes and getting around",
          "paragraphs": [
            "Antibes is about 20 km from Nice Côte d'Azur Airport. Trains stop at both Antibes and Juan-les-Pins stations, around 20–25 minutes from Nice and 10–15 minutes from Cannes.",
            "The old town, market and port are all within a short walk of the station. Local Envibus buses cover the Cap d'Antibes and Juan-les-Pins, and the coastal path is best explored on foot."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is Antibes known for?",
          "a": "Its walled old town, the Musée Picasso in the Château Grimaldi, the Provençal market, Port Vauban with its superyachts, and the Cap d'Antibes. Its neighbour Juan-les-Pins is famous for sandy beaches and the Jazz à Juan festival."
        },
        {
          "q": "When is Jazz à Juan?",
          "a": "Jazz à Juan takes place every July in the Pinède Gould, a pine grove by the sea in Juan-les-Pins. It's one of Europe's oldest jazz festivals, running since 1960."
        },
        {
          "q": "How do I get from Nice to Antibes?",
          "a": "Regional trains take about 20–25 minutes from Nice-Ville to Antibes station, which is a short walk from the old town. Buses also run along the coast from Nice airport."
        },
        {
          "q": "Is Antibes better than Cannes or Nice for a stay?",
          "a": "Antibes is smaller and more relaxed than Nice or Cannes, with a real old-town feel and good beaches in Juan-les-Pins, yet it's only a short train ride from both — a good choice for a quieter base."
        }
      ]
    },
    "sttropez": {
      "sections": [
        {
          "heading": "Top things to do in Saint-Tropez",
          "paragraphs": [
            "Start at the Old Port, where yachts moor in front of pastel houses and café terraces like Sénéquier. Behind it, the old fishermen's quarter of La Ponche leads to a tiny beach, and a short climb brings you to the Citadel, which houses a maritime history museum and looks out over the gulf. Art lovers shouldn't miss the Musée de l'Annonciade, with works by Signac, Matisse and Bonnard, the painters who first put the village on the map.",
            "On Tuesday and Saturday mornings, the Place des Lices market fills with Provençal produce under the plane trees — the square is also where locals play pétanque. The famous beaches, including Pampelonne, stretch along the neighbouring commune of Ramatuelle, and the coastal path around the peninsula links quiet coves and viewpoints."
          ]
        },
        {
          "heading": "Events and the best time to visit Saint-Tropez",
          "paragraphs": [
            "Saint-Tropez keeps its traditions alive: the Bravades, held every May 16–18 since the 16th century, fill the streets with musket salutes and processions in honour of the town's patron saint. In late September and early October, Les Voiles de Saint-Tropez brings classic yachts and modern racers to the gulf.",
            "July and August are glamorous but very busy, with traffic jams on the only road into town. June and September offer warm water, easier access and the village at its most charming."
          ]
        },
        {
          "heading": "Getting to Saint-Tropez and getting around",
          "paragraphs": [
            "Saint-Tropez has no train station. The nearest is Saint-Raphaël, with buses onward, and the nearest airports are Toulon-Hyères and Nice (about 1.5–2 hours by road). The most pleasant way in is by sea: ferries cross from Sainte-Maxime in about 15 minutes year-round, and seasonal boats run from Saint-Raphaël, Cannes and Nice.",
            "The village itself is small and best explored on foot. For the beaches of Pampelonne and the hill village of Ramatuelle, use local buses, a taxi or a bike."
          ]
        }
      ],
      "faq": [
        {
          "q": "Is there a train to Saint-Tropez?",
          "a": "No. The nearest station is Saint-Raphaël, about 35 km away, with buses to Saint-Tropez. Many visitors instead take the ferry from Sainte-Maxime, or a seasonal boat from Saint-Raphaël, Cannes or Nice."
        },
        {
          "q": "Can you do a day trip to Saint-Tropez from Nice or Cannes?",
          "a": "Yes. In season, boats run from Nice and Cannes and give you several hours in the village, and many guided day tours include transport. By road, allow at least two hours each way in summer traffic."
        },
        {
          "q": "When is the market in Saint-Tropez?",
          "a": "The Place des Lices market runs on Tuesday and Saturday mornings year-round, with fruit, vegetables, cheese, Provençal fabrics and antiques."
        },
        {
          "q": "Where is Pampelonne beach?",
          "a": "Pampelonne is a 5 km stretch of sand just south of Saint-Tropez, in the neighbouring commune of Ramatuelle. It's lined with beach clubs, but there are also public sections with free access."
        }
      ]
    },
    "menton": {
      "sections": [
        {
          "heading": "Top things to do in Menton",
          "paragraphs": [
            "Menton's old town climbs from the sea in warm Italian colours to the Baroque Basilica of Saint-Michel-Archange, whose pebble-mosaic square has one of the best views on the coast. Down by the water, the Musée Jean Cocteau holds a major collection of the artist's work, and his decoration of the Wedding Hall in the town hall is open to visitors.",
            "Menton is also a garden town, thanks to the mildest climate in mainland France. The Val Rahmeh botanical garden and the Serre de la Madone are both worth the detour, and the covered market (Les Halles) is the place to taste the town's famous lemons. For a walk, the coastal path around nearby Cap Martin passes Le Corbusier's famous cabin."
          ]
        },
        {
          "heading": "Events and the best time to visit Menton",
          "paragraphs": [
            "Menton's big moment is the Fête du Citron in February, held since the 1930s: giant sculptures made of lemons and oranges in the Biovès gardens and parades of citrus-covered floats along the seafront. In summer, the Menton Music Festival stages chamber music concerts on the basilica square, one of the Riviera's most beautiful open-air venues.",
            "Thanks to its microclimate, Menton is pleasant almost all year. Winter and spring are ideal for gardens and walks, while June and September bring warm sea without the summer crowds."
          ]
        },
        {
          "heading": "Getting to Menton and getting around",
          "paragraphs": [
            "Menton is the last French town before Italy, about 30 km east of Nice. Trains from Nice take around 35 minutes, stopping at Menton and Menton-Garavan stations, and Monaco is just 10 minutes away. Nice Côte d'Azur is the nearest international airport.",
            "The town centre, old town and seafront are all walkable. Across the border, Ventimiglia's big Friday market is a short train or bus ride away."
          ]
        }
      ],
      "faq": [
        {
          "q": "When is the Menton Lemon Festival?",
          "a": "The Fête du Citron takes place in February, over about two weeks. Tickets are needed for the parades and the citrus sculptures in the Biovès gardens, so book ahead for weekends."
        },
        {
          "q": "How do I get from Nice to Menton?",
          "a": "Regional trains run along the coast from Nice-Ville to Menton in about 35 minutes, passing through Villefranche-sur-Mer and Monaco. Buses follow the coast road too."
        },
        {
          "q": "Is Menton worth visiting?",
          "a": "Yes — it's the calmest of the Riviera towns, with an Italian-feeling old town, excellent gardens, the Musée Jean Cocteau and a mild climate all year. It combines easily with a visit to Monaco."
        },
        {
          "q": "Can you visit Italy from Menton?",
          "a": "Easily. The Italian border is just outside town, and Ventimiglia is about 10 minutes away by train — its large Friday market is a popular half-day trip."
        }
      ]
    },
    "villefranche": {
      "sections": [
        {
          "heading": "Top things to do in Villefranche-sur-Mer",
          "paragraphs": [
            "Villefranche's old town tumbles down to one of the deepest natural harbours in the Mediterranean. By the fishing port, the tiny Chapelle Saint-Pierre was decorated by Jean Cocteau in 1957 with scenes of the life of Saint Peter and of the town's fishermen. Just behind, the Rue Obscure is a vaulted medieval street that runs under the houses for more than 100 metres.",
            "The 16th-century Citadelle Saint-Elme now houses the town hall, gardens and free museums. The sandy Marinières beach curves along the bay, and next door the Saint-Jean-Cap-Ferrat peninsula is home to the Villa Ephrussi de Rothschild and its gardens, with the Greek-style Villa Kérylos in Beaulieu a little further on."
          ]
        },
        {
          "heading": "Events and the best time to visit Villefranche-sur-Mer",
          "paragraphs": [
            "Villefranche keeps a village calendar: in February, the Combat Naval Fleuri sees decorated fishing boats battle with flowers in the harbour, and summer brings concerts, festivals and evening events on the waterfront and in the Citadelle.",
            "May, June and September are ideal for swimming and walks around the bay. Cruise ships often anchor in the harbour, so mornings on those days can be busy — late afternoon is the best time to enjoy the old town."
          ]
        },
        {
          "heading": "Getting to Villefranche-sur-Mer and getting around",
          "paragraphs": [
            "Villefranche-sur-Mer sits between Nice and Monaco. Trains from Nice take less than 10 minutes and stop just above Marinières beach; Nice Côte d'Azur Airport is about 20 minutes away by road.",
            "The old town and harbour are walkable, though steep. Buses run along the coast to Nice, Beaulieu-sur-Mer and Saint-Jean-Cap-Ferrat, and the coastal path around the cape starts nearby."
          ]
        }
      ],
      "faq": [
        {
          "q": "How do I get from Nice to Villefranche-sur-Mer?",
          "a": "Take the regional train: it takes less than 10 minutes from Nice-Ville. The station sits just above the beach, a short walk from the old town. Buses along the coast road are another option."
        },
        {
          "q": "Is Villefranche-sur-Mer worth a visit?",
          "a": "Yes. It's one of the best-preserved villages on the Riviera, with a colourful old town, the Cocteau chapel, a sandy beach and an easy connection to Saint-Jean-Cap-Ferrat — and it's only minutes from Nice."
        },
        {
          "q": "Is there a beach in Villefranche-sur-Mer?",
          "a": "Yes, the Plage des Marinières is a long, gently sloping beach of fine gravel and sand along the bay, right below the train station, with calm water that's good for swimming."
        },
        {
          "q": "What is near Villefranche-sur-Mer?",
          "a": "Saint-Jean-Cap-Ferrat with the Villa Ephrussi de Rothschild, Beaulieu-sur-Mer with the Villa Kérylos, and the hilltop village of Èze are all close by. Nice is under 10 minutes by train and Monaco about 15."
        }
      ]
    }
  }
}
